<template>
  <div class="receive-gift-box">
    <div class="send-user-info">
      <van-image class="avatar" :src="user.avatar" radius="15px" show-error show-loading />
      <div class="send-message">{{ user.nickname }} 赠送给您：</div>
    </div>

    <van-image class="logo" :src="subject.bigLogoImg" radius="8px" show-error show-loading />
    <div class="title">{{ subject.title }}</div>
    <div class="price">¥ {{ subject.fullPrice }}</div>

    <van-divider class="divider">赠言</van-divider>
    <div class="message">赠吾友，请你把这最诚挚的祝福带在身边</div>
    <van-divider class="divider" />

    <div class="button" @click="receive">领取赠课</div>
    <div class="tip">注：仅限未使用过明明城堡的新用户领取哟~</div>

    <div class="tab-contents">
      <div class="tab-content">
        <div v-html="subject.content"></div>
      </div>
      <div class="tab-content">
        <div v-html="subject.indexContent"></div>
        <!-- 评论 -->
      </div>
      <div class="tab-content">
        <div v-html="subject.noticeContent"></div>
      </div>
    </div>
    <ActiveSubscribe :isShow="isShowActiveSubscribe" :onClose="closeActiveSubscribe" />
  </div>
</template>
<script>
import ActiveSubscribe from '@/components/ActiveSubscribe'
import { getReceiveSubjectInfo, acceptSubject } from './query.gql'
export default {
  name: 'ReceiveGift',
  components: {
    ActiveSubscribe
  },
  data() {
    return {
      isShowActiveSubscribe: false,
      user: {},
      my: {},
      subject: {}
    }
  },
  async mounted() {
    await this.weixinAuth()
    this.loadData()
  },
  methods: {
    loadData() {
      // 请求数据
      const self = this
      self.$toast.loading({
        mask: true,
        duration: 0,
        message: '加载中'
      })
      let id = parseInt(self.$route.query.id)
      let code = self.$route.query.invitationCode
      self.$apollo.query({
        query: getReceiveSubjectInfo,
        variables: { id, code },
        fetchPolicy: 'no-cache'
      }).then(res => {
        self.user = res.data.userProfile
        self.my = res.data.profile
        self.subject = res.data.subject
        self.setShare()
        self.$toast.clear()
        // 如果发现赠送者和打开的人是同一个人，就重新进入赠送的页面
        if (self.user.id === self.my.id) {
          this.loadPage('giftDetail', { id: id })
        }
      }).catch(err => {
        console.error('page：gift/receive。请求getReceiveSubjectInfo报错', err)
        self.$toast.clear()
        self.$toast.fail('加载数据出错')
      })
    },
    setShare() {
      const self = this
      let id = parseInt(self.$route.query.id)
      // 设置分享
      self.wechatShare({
        title: `${self.user.nickname}送了一个优质好课给您`,
        imgUrl: self.subject.smallLogoImg,
        desc: `${self.user.nickname}推荐${self.subject.shareContent}`,
        link: `${window.location.origin}/?#/gift/receive?id=${id}&invitationCode=${self.user.invitationCode}`
      })
    },
    receive() {
      const self = this
      // 如果是老用户，则不能领取课程，给出Toast提示
      // 未购过课的用户，就算新用户
      if (self.my.isBuySubject) {
        self.$toast.fail('老用户无法领取课程')
        return
      }
      self.$toast.loading({
        mask: true,
        duration: 0,
        message: '正在领取'
      })
      let id = parseInt(self.$route.query.id)
      let code = self.$route.query.invitationCode
      self.$apollo.mutate({
        mutation: acceptSubject,
        variables: { input: {
          subjectId: id,
          userInvitationCode: code
        } }
      }).then(res => {
        self.$toast.success('领取成功!')
        if (!self.my.subscribe) { // 用户需要弹出关注提醒
          self.isShowActiveSubscribe = true
        } else { // 用户无需关注提醒直接进入课程页面
          self.loadPage('learn', { id })
        }
        self.$toast.clear()
      }).catch(err => {
        console.error('page: gift/receive。请求acceptSubject报错', err)
        self.$toast.clear()
        self.$toast.fail(err.graphQLErrors[0].message || '领取失败')
      })
    },
    closeActiveSubscribe() {
      this.isShowActiveSubscribe = false
    }
  }
}
</script>
<style lang="scss">
  .receive-gift-box{
    .send-user-info {
      padding: 8px;
      display: flex;
      align-items: center;
      box-shadow: 0px 0px 10px #CCCCCC;
      .avatar {
        width: 30px;
        height: 30px;
      }
      .send-message {
        margin-left: 16px;
        color: black;
        font-size: 14px;
        font-weight: 600;
      }
    }
    .logo {
      width: calc(100% - 64px);
      margin: 24px 32px 8px 32px;
    }
    .title {
      padding: 0px 32px 0px 32px;
      text-align: center;
      color: black;
      font-size: 16px;
      font-weight: 600;
    }
    .price {
      text-align: center;
      color: #FF3D00;
      margin-top: 16px;
      font-size: 18px;
      font-weight: 600;
      text-decoration: line-through;
    }
    .divider {
      margin-left: 16px;
      margin-right: 16px;
    }
    .message {
      text-align: center;
      font-size: 14px;
      font-weight: 400;
    }
    .button {
      margin: 32px auto 0px auto;
      width: 50%;
      background: #FFCC09;
      line-height: 50px;
      color: #B93600;
      font-weight: 600;
      text-align: center;
      border-radius: 30px;
      box-shadow: 0px 0px 10px #CCCCCC;
    }
    .tip {
      margin: 16px;
      color: #BF3A00;
      text-align: center;
      font-size: 14px;
      font-weight: 400;
    }
    // 课程详情
    .tab-contents {
      padding-top: 16px;
      background: #fff;
      .tab-content {
        width: 100%;
        img {
          width: 100%;
        }
        .messageImgBox{
          position: relative;
          .message_item_box{
            position: absolute;
            left: 0;
            top: 0;
            min-width: 300rpx;
            padding: 70px 37.5px 45px;
            .message_title_img{
              width: 242.5px;
              height: auto;
              position: absolute;
              left: 0;
              right: 0;
              top: 5px;
              margin: 0 auto;
            }
            .message_item{
              display: flex;
              padding: 10px 0 20px;
              border-bottom: 1px solid #be8224;
              .message_user_img{
                width: 40px;
                height: 40px;
                border-radius: 20px;
                overflow: hidden;
                margin-right: 16px;
              }
              .message_text{
                flex: 1;
                font-size: 13px;
                .message_title{
                  color: #474747;

                  margin-bottom: 8px;
                }
                .message_desc{
                  color: #642408;
                }
              }
            }
          }
        }
      }
    }
  }
</style>
